import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import usePageMeta from '@/hooks/usePageMeta';

const quickLinks = [
  { to: '/', icon: 'ri-home-4-line', label: 'Startseite' },
  { to: '/leistungen', icon: 'ri-settings-3-line', label: 'Leistungen' },
  { to: '/referenzen', icon: 'ri-image-line', label: 'Referenzen' },
  { to: '/kontakt', icon: 'ri-map-pin-2-line', label: 'Kontakt' },
];

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: '404 – Seite nicht gefunden | gowiTEC',
    description: 'Die gesuchte Seite existiert nicht oder wurde verschoben. Besuchen Sie die Startseite von gowiTEC – Sondermaschinenbau & Automatisierungstechnik Reichshof.',
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />

      <main className="flex-1 flex items-center justify-center py-24 px-6">
        <div className="max-w-2xl w-full text-center">

          {/* 404 Hintergrundtext */}
          <div className="relative mb-8">
            <span className="text-[10rem] md:text-[14rem] font-black text-gray-50 select-none pointer-events-none leading-none block">
              404
            </span>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#1E3A8A]/10 rounded-full mb-4">
                <i className="ri-error-warning-line text-3xl text-[#1E3A8A]"></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                Seite nicht gefunden
              </h1>
              <p className="text-gray-500 text-sm font-mono bg-gray-50 px-3 py-1 rounded-md border border-gray-100">
                {location.pathname}
              </p>
            </div>
          </div>

          {/* Beschreibung */}
          <p className="text-gray-500 text-base leading-relaxed mb-10 max-w-md mx-auto">
            Die gesuchte Seite existiert leider nicht oder wurde verschoben.
            Vielleicht hilft Ihnen einer der folgenden Links weiter.
          </p>

          {/* Quick Links */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-10">
            {quickLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="flex flex-col items-center gap-2 bg-[#f8fafc] border border-gray-100 rounded-xl p-4 hover:border-[#1E3A8A]/30 hover:bg-[#EFF6FF] transition-all duration-200 cursor-pointer group"
              >
                <span className="w-10 h-10 flex items-center justify-center bg-white border border-gray-100 rounded-lg group-hover:border-[#1E3A8A]/20 transition-colors">
                  <i className={`${link.icon} text-[#1E3A8A] text-lg`}></i>
                </span>
                <span className="text-gray-700 text-sm font-medium whitespace-nowrap">{link.label}</span>
              </Link>
            ))}
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#1E3A8A] hover:bg-[#1e40af] text-white text-sm font-semibold px-6 py-3 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line"></i>
              </span>
              Zurück zur Startseite
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-white border border-gray-200 hover:border-[#1E3A8A]/30 text-gray-700 hover:text-[#1E3A8A] text-sm font-semibold px-6 py-3 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-send-line"></i>
              </span>
              Kontakt aufnehmen
            </Link>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}
